import View from 'ln/view/View';
import Signal from 'ln/signal/Signal';
import List from 'ln/list/List';
import ListRenderer from 'ln/list/ListRenderer';
import Node from 'ln/node/Node';
import Template from 'ln/template/TemplateManager';
import setup from 'ln/setup/setup';
import Lang from 'ln/lang/Lang';
import { backend } from 'typescript/src/setup';

interface Sequence {
	modelName:string,
	id:string
}

interface Course{
	modelName:string,
	title:string,
	id:string
}

interface SequenceSelected {
	( sequence:Sequence )
}

class SequenceImporter extends View {

	private sequences:List<Sequence>;
	private renderer:ListRenderer<Sequence>;

	public selected:Signal<SequenceSelected> = new Signal<SequenceSelected>();

	private static courseCache:Array<Course>;
	private query:string = '*'
	private courseId:string = '';
	private time:string = '';
	

	constructor() {
		super();
		
		this.sequences = new List<Sequence>();
		this.defaultTemplate = 'krw.sequence-importer';

		this.render();

	}

	public init() {

		this.renderer = new ListRenderer<Sequence>( this.node.js( 'results' ) );
		this.renderer.source = this.sequences;
		
		this.renderer.source.filled.add( ( items ) => {
			this.node.js( 'empty' ).toggleClass( 'hidden', items.length > 0 );
		});

		var t = this;

		this.renderer.defaultRender( ( sequence:Sequence ) => {
			let templateKey = sequence.modelName.toLocaleLowerCase().indexOf( 'slrg' ) > -1 ? 'krw.slrgsequence-importer-listitem' : 'krw.sequence-importer-listitem';
			var node = Node.fromHTML( Template.render( templateKey, sequence ) );
			node.js( 'select-btn' ).click.add( () => {
				t.onNodeClick( node );
			}, t );
			return { node:node, sequence:sequence }
		});

		this.node.js( 'search' ).click.add( this.searchSequences, this );

		this.node.js( 'search-query' ).change.add( ( n:Node, e:Event ) => {
			this.setSearchQuery( n.value );
		});
		this.node.js('search-query').keydown.add( ( n:Node, e:KeyboardEvent ) => {
			if( e.key == 'Enter' ){
				this.setSearchQuery( n.value );
				this.searchSequences();
			}
		});

		this.node.js( 'time-query' ).change.add( ( n:Node, e:Event ) => {
			this.setTimeQuery( n.value );
		});
		this.node.js('time-query').keydown.add( ( n:Node, e:KeyboardEvent ) => {
			if( e.key == 'Enter' ){
				this.setTimeQuery( n.value );
				this.searchSequences();
			}
		});

		if( !SequenceImporter.courseCache ){
			setup.route( 'api.courses' ).load().then( ( courses:Course[] ) => {
				SequenceImporter.courseCache = courses;
				this.renderCoursesDropDown();
			});
		} else {
			this.renderCoursesDropDown();
		}

	}

	private setSearchQuery( value:string ){
		if( value.length >= 3 ){
			this.query = value;
		} else {
			this.query = '*';
		}
	}

	private setTimeQuery( value:string ){
		if( value.length > 0 ){
			this.time = value;
		} else {
			this.time = '';
		}
	}

	private renderCoursesDropDown(){
		
		SequenceImporter.courseCache.forEach( ( course ) => {
			var option = Node.fromHTML( '<option value="' + course.id + '">' + course.title + '</option>' );
			this.node.js( 'course-dropdown' ).append( option );
		});

		this.node.js( 'course-dropdown' ).append( Node.fromHTML( '<option value="individual">' + Lang.translate( 'processplan.individual-sequences' )));

		this.node.js( 'course-dropdown' ).change.add( ( n:Node, e:Event ) => {
			this.courseId = n.value;
			this.searchSequences();
		});
	}

	private searchSequences() {

		this.node.js( 'search-spinner' ).removeClass( '-hidden' );
		this.node.js( 'results' ).empty();
		this.node.js( 'empty' ).addClass( 'hidden' );

		let queryData = {
			query: this.query,
			course_id: this.courseId,
			time: this.time,
			resource: false
		};
		setup.route( 'api.searchsequences' ).send( JSON.stringify( queryData )).then( this.onSequences.bind( this ) ).catch( console.error );

	}

	private onSequences( sequences:Array<Sequence> ) {
		
		sequences = backend.mapper.model( sequences );
		this.node.js( 'search-spinner' ).addClass( '-hidden' );
		this.sequences.fill( sequences );

	}


	private onNodeClick( node:Node ) {
		var link = this.renderer.linkOf( node );
		this.selected.dispatch( link.item );
	}
}

export default SequenceImporter;